__turbopack_context__.v({
  "videoContainer": "StreamVideoTab-module-scss-module__1ZDpnW__videoContainer",
  "videoDate": "StreamVideoTab-module-scss-module__1ZDpnW__videoDate",
  "videoDescription": "StreamVideoTab-module-scss-module__1ZDpnW__videoDescription",
  "videoListContainer": "StreamVideoTab-module-scss-module__1ZDpnW__videoListContainer",
  "videoTemplateContainer": "StreamVideoTab-module-scss-module__1ZDpnW__videoTemplateContainer",
  "videoTitle": "StreamVideoTab-module-scss-module__1ZDpnW__videoTitle",
});
